import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { FieldArray, useFormikContext } from 'formik';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
export const TechnicalProficiencyForm = ({ handleChange, values, handleBlur, errors, touched }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div className="signite-form">
      <FieldArray name="technicalProficiencies">
        {({ remove, push }) => (
          <>
            {values.technicalProficiencies &&
              values.technicalProficiencies.length > 0 &&
              values.technicalProficiencies.map((technicalProficiency, index) => (
                <div key={index}>
                  <Row className="mb-3">
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Skill</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`technicalProficiencies.${index}.skill`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `technicalProficiencies.${index}.skill`
                        )}`}
                        value={technicalProficiency.skill}
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `technicalProficiencies.${index}.skill`)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Rate Yourself Out Of 5</BSForm.Label>
                      <BSForm.Select
                        name={`technicalProficiencies.${index}.rating`}
                        value={technicalProficiency.rating}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `technicalProficiencies.${index}.rating`
                        )}`}
                      >
                        <option value="">--Select--</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </BSForm.Select>
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `technicalProficiencies.${index}.rating`)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Key Project</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`technicalProficiencies.${index}.keyProject`}
                        value={technicalProficiency.keyProject}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `technicalProficiencies.${index}.keyProject`
                        )}`}
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `technicalProficiencies.${index}.keyProject`)}
                      </span>
                    </BSForm.Group>
                  </Row>

                  <Row>
                    <Col>
                      <LinkButton label="Remove Skill" onClick={() => remove(index)} icon={faMinusCircle}></LinkButton>
                    </Col>
                  </Row>
                  <hr
                    style={{
                      marginTop: 32,
                      marginBottom: 32,
                    }}
                  />
                </div>
              ))}
            <Row>
              <Col>
                <LinkButton
                  label="Add Skill"
                  onClick={() =>
                    push({
                      skill: '',
                      rating: '',
                      keyProject: '',
                    })
                  }
                ></LinkButton>
              </Col>
            </Row>
          </>
        )}
      </FieldArray>
    </div>
  );
};
